import InativacaoLoteItemModel from "./InativacaoLoteItemModel";

const toItens = (itens) => {
  if (!Array.isArray(itens)) return new Array();
  return itens.map((item) =>
    item instanceof InativacaoLoteItemModel
      ? item
      : new InativacaoLoteItemModel(item)
  );
};

export default class InativacaoLotePreviewModel {
  constructor(
    { previewToken, previewExpiraEm, contatos, siglasCcee, ucs } = new Object()
  ) {
    this._previewToken = previewToken;
    this._previewExpiraEm = previewExpiraEm;
    // usa os setters (não atribuição direta a _contatos/_siglasCcee/_ucs) para que os
    // itens crus da API sejam sempre convertidos para InativacaoLoteItemModel — a tabela
    // de prévia depende dos getters computados do model (categoria, isTransferencia etc).
    this.contatos = contatos;
    this.siglasCcee = siglasCcee;
    this.ucs = ucs;
  }

  get previewToken() {
    return this._previewToken || null;
  }

  set previewToken(previewToken = null) {
    this._previewToken = previewToken;
  }

  get previewExpiraEm() {
    return this._previewExpiraEm || null;
  }

  set previewExpiraEm(previewExpiraEm = null) {
    this._previewExpiraEm = previewExpiraEm;
  }

  get contatos() {
    return this._contatos || new Array();
  }

  set contatos(contatos = null) {
    this._contatos = toItens(contatos);
  }

  get siglasCcee() {
    return this._siglasCcee || new Array();
  }

  set siglasCcee(siglasCcee = null) {
    this._siglasCcee = toItens(siglasCcee);
  }

  get ucs() {
    return this._ucs || new Array();
  }

  set ucs(ucs = null) {
    this._ucs = toItens(ucs);
  }

  get todosItens() {
    return [...this.contatos, ...this.siglasCcee, ...this.ucs];
  }

  get totalItens() {
    return this.todosItens.length;
  }

  get totalErros() {
    return this.todosItens.filter((item) => item.categoria === "erro").length;
  }

  get totalAlertas() {
    return this.todosItens.filter((item) => item.categoria === "alerta")
      .length;
  }

  get totalAvisos() {
    return this.todosItens.filter((item) => item.categoria === "aviso")
      .length;
  }

  /**
   * @summary Botão "Confirmar" só é habilitado se houver ao menos 1 item sem erro.
   */
  get podeConfirmar() {
    return this.todosItens.some((item) => !item.bloqueiaConfirmacao);
  }
}
